// src/utils/messageHelper.js
let _showMessage = null;

export const registerShowMessage = (fn) => {
  _showMessage = fn;
};

export const callShowMessage = (msg, severity = "info") => {
  if (_showMessage) {
    _showMessage(msg, severity);
  } else {
    console.warn("showMessage not registered:", msg);
  }
};
